import script from "./ProposalName.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalName.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__